import http from '@util/http';
import { incubator } from '@api/req';

export async function queryTerminationList(params) {
  return http.get(incubator.TERMINATION_LIST, params);
}
export async function queryTerminationMy(params) {
  return http.get(incubator.TERMINATION_MY, params);
}
export async function queryTerminationInfo(params) {
  return http.get(incubator.TERMINATION_INFO, params);
}
export async function querySaveTermination(params) {
  return http.post(incubator.TERMINATION_SAVE, params);
}
export async function queryNextTermination(params) {
  return http.get(incubator.TERMINATION_NEXT, params);
}
export async function queryNextTerminationScan(params) {
  return http.post(incubator.TERMINATION_NEXT_SCAN, params);
}
export async function queryNextTerminationArchive(params) {
  return http.post(incubator.TERMINATION_NEXT_ARCHIVE, params);
}
export async function queryReturnTermination(params) {
  return http.post(incubator.TERMINATION_RETURN, params);
}
export async function queryCallbackTermination(params) {
  return http.get(incubator.TERMINATION_CALLBACK, params);
}
export async function queryDeleteTermination(params) {
  return http.get(incubator.TERMINATION_DELETE, params);
}
export async function queryTerminationWorkflow(params) {
  return http.get(incubator.TERMINATION_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/termination.js